// extracted by mini-css-extract-plugin
export default {"main":"CentralContentPageLayout_main__tR8Jf"};